const initialState = {
  classAppetiteGuide: {
    stateList: [],
    productList: [],
    classifications: []
  }
};

export default initialState;
